/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import { modalController } from '@ionic/vue';
import Eula from '../components/Eula.vue';

const openEulaModalHandle = () => {
  const modalExist = document.querySelector('.eulaModal');
  if (!modalExist) {
    modalController
      .create({
        component: Eula,
        backdropDismiss: false,
        keyboardClose: false,
        cssClass: 'eulaModal',
      })
      .then((modalElement) => {
        modalElement.present();
        modalElement.onDidDismiss();
      });
  }
};

export { openEulaModalHandle };
